export default __webpack_public_path__ + "static/media/progress_page_framed.fa68245a.png";